import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

function loadLocaleMessages() {
  const locales = require.context('@/libs/i18n/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
  const messages = {};
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

function localeLanguage() {
  const url = window.location.pathname;
  const languageCode = url.split('/')[1];
  let name;
  if (languageCode && /^[a-zA-Z]{2}$/.test(languageCode)) {
    name = languageCode;
  }
  const newLocale = name || localStorage.getItem('appLocale') || 'en';
  return newLocale;
}

export default new VueI18n({
  locale: localeLanguage(),
  fallbackLocale: 'en',
  messages: loadLocaleMessages(),
});
